import PageShell from './PageShell';
import { Crumb } from './PageBreadcrumb';

export default function PageWithTable({
    children,
    title,
    subtitle,
    actions,
    filters = null,
    breadcrumbs,
}: any & { breadcrumbs?: Crumb[] }) {
    return (
        <PageShell
            title={title}
            subtitle={subtitle}
            actions={actions}
            filters={filters}
            breadcrumbs={breadcrumbs}
        >
            {children}
        </PageShell>
    );
}
